import { ACTION } from "@common/constants/redux";

export const setNotificationCampaignFilter = (filter) => {
  return (dispatch) => {
    dispatch({
      type: ACTION.SET_NOTIFICATION_CAMPAIGN_FILTER,
      payload: filter,
    });
  };
};
